<script lang="ts">
  import { fly } from "svelte/transition";
  import { quintOut } from "svelte/easing";
  export let modalShowing: boolean;
</script>

<style>
  .modal-cont {
    width: 325px;
    height: auto;
    position: absolute;
    z-index: 10000;
    top: 15%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    margin: 0 5px;
    padding: 10px;
    color: black;
    background-color: hsla(69, 66%, 68%, 1);
    box-shadow: 0 0 10px black;
    border: 1px solid #666;
    transition: top 1s ease-in-out;
  }

  @keyframes blink {
    to {
      opacity: 0;
    }
  }

  .hide {
    top: -600px;
  }
</style>

<!-- svelte-ignore a11y-missing-attribute -->
<div
  class:hide={!modalShowing}
  class="modal-cont"
  transition:fly={{ duration: 300, y: 500, easing: quintOut }}>
  <slot />
</div>
